<script>
import {client} from "../../sci/helpers";
import ConstructionModalDetailsTab from "./Modal/ConstructionModalDetailsTab.vue";
import ConstructionInternalInfoTab from "./Modal/ConstructionInternalInfoTab.vue";
import ConstructionBuildingTab from "./Modal/ConstructionBuildingTab.vue";
import ConstructionPricesTab from "./Modal/ConstructionPricesTab.vue";
import ConstructionInstallmentsTab from "./Modal/ConstructionInstallmentsTab.vue";
import ConstructionFeaturesTab from "./Modal/ConstructionFeaturesTab.vue";
import ConstructionPhotoTab from "./Modal/ConstructionPhotoTab.vue";
import {url} from "../../sci/utils";
import ConstructionCustomerInterestedTab from "./Modal/ConstructionCustomerInterestedTab.vue";
import ConstructionDocumentTab from "./Modal/ConstructionDocumentTab.vue";

export default {
    name: "ConstructionModal",
    components: {
        ConstructionDocumentTab,
        ConstructionCustomerInterestedTab,
        ConstructionPhotoTab,
        ConstructionFeaturesTab,
        ConstructionInstallmentsTab,
        ConstructionPricesTab,
        ConstructionBuildingTab, ConstructionInternalInfoTab, ConstructionModalDetailsTab},
    props: {
        constructionId: {required: true},
        limit: {required: false},
        circling: {required: false, default: () => []}
    },
    data() {
        const circlingData = this.circling || []
        return {
            shallowConstruction: this.construction,
            construction: {},
            ui: {
                loading: true,
                currentConstructionId: this.constructionId
            },
            currentItem: circlingData.indexOf(this.constructionId),
            displayAll: false,
            shows: [],
            activeTab: 'details'
        }
    },
    ready() {
        this.load()
    },
    computed: {
        hasBuilding() {
            return !!(this.construction && this.construction.building)
        },
        hasFeatures() {
            const c = this.construction
            return !!((c.features || []).length > 0 || (c.rooms || []).length > 0)
        },
        mapIframePath() {
            return `${url('/utils/google-maps')}?latitude=${this.construction.latitude}&longitude=${this.construction.longitude}&title=imóvel`;
        },
        hasNext() {
            return  this.circling.length - 1 > this.currentItem
        },
        hasPrevious() {

            return this.currentItem > 0;
        }
    },
    methods: {
        toNext() {
            if (! this.hasNext) {
                return;
            }
            this.currentItem = this.currentItem + 1;
            this.changeItem()
        },
        toPrevious() {
            if (! this.hasPrevious) {
                return;
            }
            this.currentItem = this.currentItem - 1;
            this.changeItem()
        },
        changeItem() {
            this.ui.currentConstructionId = this.circling[this.currentItem];
            this.load()
        },
        async load() {
            this.ui.loading = true;
            const constructionResponse = await client.get(null, `/constructions/${this.ui.currentConstructionId}`)
            this.construction = constructionResponse.data
            this.ui.loading = false;
        },
        toggleShow(key) {
            this.shows = {
                ...this.shows,
                [key]: !this.shows[key]
            };
        },
        showAll() {
            this.displayAll = !this.displayAll
        },
        setTab(tab, condition = true) {
            if (condition) this.activeTab = tab
        }
    }
}
</script>

<template>
    <div>
        <div class="modal-header">
            <h4 class="modal-title" style="flex-grow: 1;">
                <div class="flex-row" style="align-items: center">
                    <div class="flex-col-0" style="width: 100%">
                        <div v-if="!ui.loading">
                            {{ construction.type_name }}
                            <span v-if="construction.subtype_name"> - {{ construction.subtype_name }}</span>
                            {{ construction.neighborhood.name }}, {{ construction.city.name }}
                            - Cód.:
                            <span>{{ construction.user_code }}</span>
                        </div>
                    </div>
                    <span style="font-size: 12px; margin-right: 15px; flex-shrink: 0; white-space: nowrap" v-if="limit > 0">Imóvel: {{currentItem}} de {{limit}}</span>
                    <button  @click='showAll()' class="btn btn-sm blue pull-right" style="flex-shrink: 0; white-space: nowrap; margin-right: 15px;">
                        <span v-if="!displayAll">Exibir</span> <span v-else>Ocultar</span> informações
                    </button>
                    <button @click="$emit('close')" class="new-close" type="button" data-dismiss="modal" aria-hidden="true" v-tooltip title="Fechar" style="margin-right: 15px; flex-shrink: 0">
                        &times;
                    </button>
                </div>
            </h4>
        </div>
        <div class="modal-body">
            <div v-if="ui.loading">
                <h4 class="text-center">Carregando...</h4>
            </div>
            <div v-if="! ui.loading && construction">
                <ul class="nav nav-tabs">
                    <li :class="{active: activeTab === 'details'}">
                        <a href="javascript:;" @click.prevent="setTab('details')">Informações Gerais</a>
                    </li>
                    <li :class="{active: activeTab === 'internal'}">
                        <a href="javascript:;" @click.prevent="setTab('internal')">Informações internas</a>
                    </li>
                    <li :class="{active: activeTab === 'building', disabled: !hasBuilding}">
                        <a href="javascript:;" @click.prevent="setTab('building', hasBuilding)">Cond./Emp.</a>
                    </li>
                    <li :class="{active: activeTab === 'prices'}">
                        <a href="javascript:;" @click.prevent="setTab('prices')">Valores</a>
                    </li>
                    <li :class="{active: activeTab === 'installments'}">
                        <a href="javascript:;" @click.prevent="setTab('installments')">Parcelas</a>
                    </li>
                    <li :class="{active: activeTab === 'features', disabled: !hasFeatures}">
                        <a href="javascript:;" @click.prevent="setTab('features', hasFeatures)">Características</a>
                    </li>
                    <li :class="{active: activeTab === 'photos'}">
                        <a href="javascript:;" @click.prevent="setTab('photos')">Fotos</a>
                    </li>
                    <li :class="{active: activeTab === 'geolocation', disabled: !(construction.latitude && construction.longitude)}">
                        <a href="javascript:;" @click.prevent="setTab('geolocation', !!(construction.latitude && construction.longitude))">Mapa</a>
                    </li>
                    <li :class="{active: activeTab === 'recommended', disabled: !construction.interested_count}">
                        <a href="javascript:;" @click.prevent="setTab('recommended', !!construction.interested_count)">Recomendados ({{ construction.interested_count || 0 }})</a>
                    </li>
                    <li :class="{active: activeTab === 'documents', disabled: !construction.documents || !construction.documents.length}">
                        <a href="javascript:;" @click.prevent="setTab('documents', !!(construction.documents && construction.documents.length))">Documentos</a>
                    </li>
                </ul>
                <div class="tab-content">
                    <div v-show="activeTab === 'details'" style="padding-top: 15px;">
                        <construction-modal-details-tab @shows="toggleShow" :shows="shows" :construction="construction"></construction-modal-details-tab>
                    </div>
                    <div v-show="activeTab === 'internal'" style="padding-top: 15px;">
                        <construction-internal-info-tab :construction="construction" :shows="shows" @shows="toggleShow"></construction-internal-info-tab>
                    </div>
                    <div v-show="activeTab === 'building'" v-if="construction.building" style="padding-top: 15px;">
                        <construction-building-tab :construction="construction" :shows="shows" @shows="toggleShow"></construction-building-tab>
                    </div>
                    <div v-show="activeTab === 'prices'" style="padding-top: 15px;">
                        <construction-prices-tab :construction="construction" :shows="shows" @shows="toggleShow"></construction-prices-tab>
                    </div>
                    <div v-show="activeTab === 'installments'" style="padding-top: 15px;">
                        <construction-installments-tab :construction="construction" :shows="shows" @shows="toggleShow"></construction-installments-tab>
                    </div>
                    <div v-show="activeTab === 'features'" style="padding-top: 15px;">
                        <construction-features-tab :construction="construction" :shows="shows" @shows="toggleShow"></construction-features-tab>
                    </div>
                    <div v-show="activeTab === 'photos'" style="padding-top: 15px;">
                        <construction-photo-tab :construction="construction" :shows="shows" @shows="toggleShow"></construction-photo-tab>
                    </div>
                    <div v-show="activeTab === 'geolocation'" style="padding-top: 15px;">
                        <iframe v-if="activeTab === 'geolocation'" :src="mapIframePath" style="width: 100%;height: 400px;display: block"></iframe>
                    </div>
                    <div v-show="activeTab === 'recommended'" style="padding-top: 15px;">
                        <construction-customer-interested-tab :construction="construction" :shows="shows" @shows="toggleShow"></construction-customer-interested-tab>
                    </div>
                    <div v-show="activeTab === 'documents'" style="padding-top: 15px;">
                        <construction-document-tab :construction="construction" :shows="shows" @shows="toggleShow"></construction-document-tab>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="col-md-5 pull-left">
                <a :disabled="!hasPrevious"  v-on:click="toPrevious" class="btn default pull-left"
                   target="_blank"> <i class="fa fa-angle-double-left"> </i> Imóvel Anterior</i></a>
            </div>
            <div class="col-md-5">
                <a v-if="construction && construction.editable" class="btn blue"
                   href="{{ construction.url | url }}" target="_blank"> Editar</a>


                <button v-if="hasNext" v-on:click="toNext" class="btn default">
                    <i class="fa fa-angle-double-right"></i>
                    Próximo Imóvel
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConstructionModal.vue?58060e9f